import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../context/store.provider";
import { ROUTES_LINKS } from "../../routes/routes";
import { priceFormatter } from "./algoritem";

function Inventory() {
  const { storeProducts } = useStore();
  const [productsOutOfStock, setProductsOutOfStock] = useState([]);
  const navigate = useNavigate();
  const onClickEdit = (id) => {
    navigate(ROUTES_LINKS.TO_EDIT_PRODUCT.replace(":id", id));
  };
  // here need to get the list of all product with condition of outOfStock true

  useEffect(() => {
    const productsOutOfStock = storeProducts.filter(
      (product) => product.outOfStock === true
    );
    // if product.quentity setoutOfStock: null or false
    // if product.quentity ===0 setOutOfStock = to true
    // if there is sale price show sale price with presantage down reguler price up
    // to create a form of sales and some component that holding all product that has sale price plus the sales
    setProductsOutOfStock(productsOutOfStock);
    console.log(productsOutOfStock);
  }, []);

  return (
    <div>
      <div
        style={{
          position: "fixed",
          top: 5,
          backgroundColor: "black",
          color: "white",
          fontSize: 30,
        }}
      >
        חסר במלאי
      </div>
      <div className='list-con'>
      {productsOutOfStock.map(
        ({ id, category, imgUrl, price, productName, storePrice }, index) => (
          <div className="list-product-con" key={id}>
            <h2>{productName}</h2>
            <h3>{category}</h3>
            <h4>{storePrice}</h4>
            <h4>{priceFormatter.format(price)}</h4>
            <button className="edit-product" onClick={() => onClickEdit(id)}>
              Edit
            </button>
          </div>
        )
      )}
      </div>
    </div>
  );
}

export default Inventory;
